import React, { useState } from 'react'
import './OldBudgetSummary.scss'
import { DobleGuion } from './DobleGuion'
import { EquisIcons } from '../utils/icons'
import moment from 'moment'
import { formatDdMmmYyyy } from '../hooks/formatDate'
import { SummaryProductOldBudgetMobile } from './SummaryProductOldBudgetMobile'
import { SummaryProductOldBudgetDesktop } from './SummaryProductOldBudgetDesktop'
import { setBudget, resetBudget, showSpinner } from '../actions/index'
import { connect } from 'react-redux'
import { PopupOneButton } from './PopupOneButton'
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { tokerUser } from '../hooks/user'
import axios from 'axios'
import { API, PreChangeBrandChosen } from '../hooks/config'

const OldBudgetSummary = (props) => {
    const { budgetSelected, clickClose, textButtonAdd } = props
    const [budget, setBudget] = useState(budgetSelected)
    const [repeatBudget, setRepeatBudget] = useState(false)
    const [showPopupPresupuestosPendientes, setShowPopupPresupuestosPendientes] = useState(false)

    const handleClickRepeatBudget = () => {
        const products = budget.products
        props.resetBudget()
        for (let i = 0; i < products.length; i++) {
            const product = products[i];
            props.setBudget(product)
        }
        if (textButtonAdd.toLowerCase() === 'continuar presupuesto') {
            changeBrandGlobal(budget.brand).then((res)=>{
              if(res){
                tokerUser().then(res => {
                  const headers = {
                      headers: {
                          'Content-Type': 'application/json',
                          Authorization: `Bearer ${res}`
                      }
                  };
                  axios.post(`${API}/protected/carts-delete`, {
                      id: budget.id,
                      company: budget.empresa,
                      cif: budget.cif,
                      name: budget.name,
                      phonenumber: budget.phonenumber,
                      zone: budget.zone,
                      email: budget.email,
                      role: budget.role,
                      products: JSON.stringify(props.budget)
                  }, headers)
                })
                setRepeatBudget(true)
              }
            })
        } else {
            setRepeatBudget(true)
        }
    }

    const changeBrandGlobal = (marca = 'fansa') => {
      return new Promise(async (resolve)=>{
        let marcaCambiada = await PreChangeBrandChosen(marca, budget)
        if(!marcaCambiada){
          setShowPopupPresupuestosPendientes(true)
          resolve(false)
        }else{
          resolve(true)
        }
      })
    }

    const handleClickGeneratePdf = () => {
        props.showSpinner(true)
        const input = document.getElementById("products");
        const pdf = new jsPDF({ unit: "px", format: "A4", userUnit: "px" });
        pdf.html(input, { html2canvas: { scale: 0.25 } }).then(() => {
            pdf.save("presupuesto.pdf")
            props.showSpinner(false)
        });
    }

    const handleClickEnd = () => {
        clickClose()
        setRepeatBudget(false)
    }

    return (
        <div className="old-budget-summary-container">
            {showPopupPresupuestosPendientes &&
                <PopupOneButton title="¡Presupuestos pendientes!" text="Tienes presupuestos pendientes, para cambiar de marca debes guardar o eliminar los presupuestos." textButton="Aceptar" onClick={() => setShowPopupPresupuestosPendientes(false)} />
            }
            {repeatBudget &&
                <PopupOneButton title="¡Productos añadidos!" text="Se han añadido todos los productos al presupuesto." textButton="Aceptar" onClick={handleClickEnd} />
            }
            <div className="content">
                <div className="header">
                    <div className="title">
                        <div className="text">
                            <p>PRESUPUESTOS ENVIADOS</p>
                            <DobleGuion />
                        </div>
                        <div className="botones">
                            <button className="pointer" onClick={clickClose}><EquisIcons size={15} /></button>
                        </div>
                    </div>
                    <div className="data">
                        <div className="number-budget">
                            <p>Presupuesto {budget.id}</p>
                        </div>
                        <div className="date-budget">
                            <p>{formatDdMmmYyyy(moment(budget.date, 'DD/MM/YYYY'))}</p>
                        </div>
                    </div>
                </div>
                <div className="products">
                    {budget.products.map((product, index) => {
                        return (
                            <React.Fragment key={index}>
                                <div className="product-mobile">
                                    <SummaryProductOldBudgetMobile productBudget={product} />
                                </div>
                                <div className="product-desktop">
                                    <SummaryProductOldBudgetDesktop productBudget={product} />
                                </div>
                            </React.Fragment>
                        )
                    })}
                </div>
                <div className="products products-print" id="products">
                    {budget.products.map((product, index) => {
                        return (
                            <React.Fragment key={index}>
                                <div className="product-desktop">
                                    <SummaryProductOldBudgetDesktop productBudget={product} />
                                </div>
                            </React.Fragment>
                        )
                    })}
                </div>
                <div className="botones">
                    <button className="btn" onClick={handleClickRepeatBudget}>{textButtonAdd}</button>
                    <button className="btn" onClick={handleClickGeneratePdf}>Generar PDF</button>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    setBudget,
    resetBudget,
    showSpinner
}


export default connect(null, mapDispatchToProps)(OldBudgetSummary)
